var DeliveryOptionModel = function (pageModelHndl) {
    var that = this;

    //baseData
    that.DeliveryOptionId = ko.observable();
    that.Price = ko.observable();
    that.Name = ko.observable();
    that.IsEnabled = ko.observable();

    //output
    that.DisplayPrice = ko.computed(function () {
        var signum;

        var displayPrice
        if (pageModelHndl.DiffWithPickup() > 0) {
            displayPrice = that.Price() + pageModelHndl.DiffWithPickup();
        } else {
            displayPrice = that.Price();
        }

        if (displayPrice >= 0) {
            signum = "+ ";
        }
        else {
            signum = ""; //decimal adds signum if < 0
        }

        return signum + GetCurrency(displayPrice);
    }, that);

    that.DisplayOptionsCaption = ko.computed(function () {
        return (that.Name()) + " : " + (that.DisplayPrice());
    });

    //functions
    that.RePopulateDeliveryOptionModel = function (deliveryOptionData) {
        that.IsEnabled(deliveryOptionData.Enabled);
        that.Price(deliveryOptionData.Price - pageModelHndl.InjectValue());
    };

    that.PopulateDeliveryOptionModel = function (deliveryOptionData) {
        that.DeliveryOptionId(deliveryOptionData.DeliveryOptionId);
        that.IsEnabled(deliveryOptionData.Enabled);
        that.Price(deliveryOptionData.Price - pageModelHndl.InjectValue());
        that.Name(deliveryOptionData.Name.Text);
    };
};
